import app from '../app.first';

app.InterviewRatingControl = class extends app.Component {
	onReady() {
		this.$el.find('input').on('change', async (e) => {
			app.post(this.$el, false)
				.then(response => {
					if (!response.success) this.handleError(e);
				})
				.catch(() => {
					this.handleError(e);
				});
		});

	}

	handleError(e) {
		location.reload();
	}
}